import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { QK } from '@/lib/query-keys'
import { notificationsApi } from '@/features/notifications/notifications.api'
import { documentTitle } from '@/features/notifications/notification-utils'
import { useUser } from '@/features/auth/useSession'
import { useSessionStore } from '@/stores/session.store'

export const unreadCountKey = [...QK.notifications, 'unread-count'] as const

// The hook's effect lives in the top bar, which leaves the tree on /login before it could write the plain title
// back; so the moment nobody is signed in (log-out or an expired session) the title drops the count here (LP-820).
useSessionStore.subscribe((state, prev) => {
  if (prev.user && !state.user) document.title = documentTitle(0)
})

/** Polled every minute while the tab is visible; also refreshed when a `notification` event invalidates QK.notifications. */
export function useUnreadCount(): number {
  const user = useUser()
  const { data } = useQuery({
    queryKey: unreadCountKey,
    queryFn: notificationsApi.unreadCount,
    enabled: !!user,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    staleTime: 30_000,
  })
  const count = data ?? 0
  useEffect(() => {
    document.title = documentTitle(user ? count : 0)
  }, [count, user])
  return count
}
